

















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from '@/components/common/base';
import { vendorService } from '@/shared';

@Component({
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
    },
    props: ['dialog', 'recordKey'],
})

export default class NoteComponent extends Base {
    public $validator: Validator;
    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }
    public dialog: boolean;
    public recordKey: string;
    public noteText: string = '';
    public headers: VHeaders[] = [
        {
            text: this.$parent.$t('vendorNote.headers.note') as string,
            align: 'left',
            sortable: true,
            value: 'noteText',
        },
        {
            text: this.$parent.$t('vendorNote.headers.addedAt') as string,
            value: 'createdAt',
            align: 'left',
            fieldType: 'date',
        },
        {
            text: this.$parent.$t('vendorNote.headers.addedBy') as string,
            value: 'createdByEmail',
            align: 'left',

        },
    ];
    public pagination = new PaginationModel('createdAt', true, 5);
    public items: any = [];
    public loading: boolean = false;
    public disableSaveButton: boolean = false;

    public mounted() {
        this.$watch('recordKey', (newVal, oldVal) => {
            this.getNotes(newVal);
        });
    }

    public async getNotes(recordKey): Promise<void> {
        try {
            this.loading = true;
            const response = await vendorService.getNotesAsync(recordKey);
            this.items = response.results;
            this.pagination.totalItems = response.results.length;
        } finally {
            this.loading = false;
        }
    }

    public async saveNote(): Promise<void> {
        if(this.validateForm()){
            if(!this.noteText){
                return;
            }
            try {
                this.disableSaveButton = true;
                await vendorService.addNoteAsync(this.recordKey, this.noteText);
                this.noteText = '';
                this.getNotes(this.recordKey);
                this.showAlert(true, this.$parent.$t('vendorNote.alertNoteAddedSuccessfully'));
                this.$validator.reset();
            } finally {
                this.disableSaveButton = false;
            }
        }
    }

    public closeDialog() {
        this.trigger = false;
        this.$validator.reset();
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }
}
